module.exports = __webpack_public_path__ + "img/back1.513de78a.jpg";